import {inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from './api.service';
import { IFileIntegrity } from '../interfaces/file-integrity/IFileIntegrity';
import { IFileIntegrityCheckResult } from '../interfaces/file-integrity/IFileIntegrityCheckResult';
import { IMultiApplicationFileIntegrityCheckResult } from '../interfaces/file-integrity/IMultiApplicationFileIntegrityCheckResult';
import { IApplication } from '../interfaces/IApplication';

@Injectable({
  providedIn: 'root'
})
export class FileIntegrityService {

  private apiService: APIService = inject(APIService);

  public getFileIntegrityRecords(): Observable<IFileIntegrity[]> {
    return this.apiService.MakeGetRequest<IFileIntegrity[]>('system/file-integrity/files');
  }

  public getFileIntegrityRecordsByApplication(applicationTypeIdP: number): Observable<IFileIntegrity[]> {
    return this.apiService.MakeGetRequest<IFileIntegrity[]>(`system/file-integrity/files/application/${applicationTypeIdP}`);
  }

  public getFileIntegrityRecordById(idP: string): Observable<IFileIntegrity> {
    return this.apiService.MakeGetRequest<IFileIntegrity>(`system/file-integrity/files/${idP}`);
  }

  public checkFileIntegrity(): Observable<IFileIntegrityCheckResult> {
    return this.apiService.MakePostRequest<IFileIntegrityCheckResult>('system/file-integrity/check', {});
  }

  public checkFileIntegrityByApplication(applicationTypeIdP: number): Observable<IFileIntegrityCheckResult> {
    return this.apiService.MakePostRequest<IFileIntegrityCheckResult>(`system/file-integrity/check/application/${applicationTypeIdP}`, {});
  }

  public checkAllApplicationsFileIntegrity(): Observable<IMultiApplicationFileIntegrityCheckResult> {
    return this.apiService.MakePostRequest<IMultiApplicationFileIntegrityCheckResult>('system/file-integrity/check-all-applications', {});
  }

  public getApplications(): Observable<IApplication[]> {
    return this.apiService.MakeGetRequest<IApplication[]>('system/applications');
  }

  public getActiveApplications(): Observable<IApplication[]> {
    return this.apiService.MakeGetRequest<IApplication[]>('system/applications/active');
  }

}
